@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if (setCycleType($.row.clt_subs_billing_interval_type) !== null) {
    <span>{{ setCycleType($.row.clt_subs_billing_interval_type) }} </span>
  } @else {
    -
  }
}
